<!-- 
	@component
	A very unopinionated select component. Handles the selection logic only, can
	easily build any styling around the input/selected UI + selection list itself.

	Usage:
	```svelte
	<Select bind:selected>
		<div slot="input">{selected}</div>
		<SelectItem id="one">1</SelectItem>
		<SelectItem id="two">2</SelectItem>
		<SelectItem id="three">3</SelectItem>
	</Select>
	```
 -->
<script lang="ts">
	import Popover from '../Popover/Popover.svelte';
	import Group from '../Group/Group.svelte';

	type Value = $$Generic;

	export let isOpen = false;
	export let multiple = false;
	export let mandatory = false;
	export let selected: Value[] = [];
</script>

<Group {multiple} {mandatory} bind:values={selected} on:change>
	<Popover yPos="bottom" bind:isOpen>
		<slot name="input" slot="root" />
		<ul>
			<slot />
		</ul>
	</Popover>
</Group>
